import {reactive} from "vue";

export const modalStore = reactive({
    isOpened: false,
    setIsOpened(value){
        this.isOpened = value;
    },
    article: null,
    setArticle(value){
        this.article = value;
    },
    articleSet: null,
    setArticleSet(value){
        this.articleSet = value;
    },
    service: null,
    setService(value){
        this.service = value;
    },
    category: '',
    setCategory(value){
        this.category = value;
    }
})

